import { NgModule } from '@angular/core';

import { provideAzureAuth } from './azure.auth';

/**
 * To use the build-in authentication provide by the App Service.
 *
 * @deprecated use provideAzureAuth() instead
 */
@NgModule({ providers: [provideAzureAuth()] })
export class AzureAuthModule {}
